<router-outlet></router-outlet>
<!--//    "@angular/common": "~11.2.1",-->

<!-- <app-footer *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/login' || location == '/register')"></app-footer> -->
